'use es6';

import { fromJS } from 'immutable';
import { defaultLegendOptions } from './legendOptions';
import { defaultAreaSeriesOptions } from './series/areaSeriesOptions';
import { defaultAreaRangeSeriesOptions } from './series/arearangeSeriesOptions';
import { defaultBarSeriesOptions } from './series/barSeriesOptions';
import { defaultColumnSeriesOptions } from './series/columnSeriesOptions';
import { defaultLineSeriesOptions } from './series/lineSeriesOptions';
import { defaultPieSeriesOptions } from './series/pieSeriesOptions';
import { defaultScatterSeriesOptions } from './series/scatterSeriesOptions';
import { defaultWaterfallSeriesOptions } from './series/waterfallSeriesOptions';
import { defaultSeriesOptions } from './series/seriesOptions';
import { defaultTooltipOptions } from './tooltipOptions';

// TODO, better color options
export const defaultColorOptions = ['#fea58e', '#51d3d9', '#bda9ea', '#f5c78e', '#ea90b1', '#81c1fd', '#a4d398', '#c3705c', '#009ca2', '#9784c2', '#bb915b', '#b05c7d', '#468cc4', '#6b9a5b'];

/**
 * These are options common to all charts
 * chartOptions can override these if needed
 */
export const defaultOptions = fromJS({
  chart: {
    animation: false,
    spacingRight: 50,
    style: {
      fontFamily: 'inherit'
    },
    type: 'column'
  },
  title: {
    text: null
  },
  colors: defaultColorOptions,
  plotOptions: {
    series: defaultSeriesOptions,
    area: defaultAreaSeriesOptions,
    arearange: defaultAreaRangeSeriesOptions,
    bar: defaultBarSeriesOptions,
    column: defaultColumnSeriesOptions,
    line: defaultLineSeriesOptions,
    pie: defaultPieSeriesOptions,
    scatter: defaultScatterSeriesOptions,
    waterfall: defaultWaterfallSeriesOptions
  },
  // dont edit these, going to make default axis settings for each type
  xAxis: [{}],
  yAxis: [{}],
  legend: defaultLegendOptions,
  tooltip: defaultTooltipOptions,
  credits: {
    enabled: false
  }
});